module.exports = __webpack_public_path__ + "img/End-To-End_Encryption.height-256.a9e617b9.png";